import React, { useRef } from 'react';
import { Typography } from '..';
import useClickOutside from '../../../services/Helpers/useClickOutside';

const Modal = ({ title, children, closeModal }) => {
    const modalRef = useRef(null);
    useClickOutside(modalRef, closeModal);

    return (
        <>
            <div className="fixed h-screen w-full bg-black opacity-75 inset-0 z-50 modal-backdrop" />
            <div className="fixed h-screen w-full inset-0 z-50 modal-container">
                <div className="flex h-full justify-center items-center">
                    <div
                        ref={modalRef}
                        style={{ width: '500px' }}
                        className="flex flex-col gap-4 justify-center p-10 bg-white rounded-xl modal"
                    >
                        <Typography variant="heading1.1" className="text-center mb-4">
                            {title}
                        </Typography>
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Modal;
